import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../Components/RegionSelectionSidebar.js";
import Header from "../Components/Header.js";
import { getRegionalStates, getZones, getWoredas, getKebeles } from "../Services/apiService";
import "../assets/css/Home.css";
import MapView from "./MapView.js";

const toUrl = (name) => {
  if (!name) return "";
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]/g, "");
};
const fromUrl = (url) => url.replace(/-/g, " ");
const Home = () => {
  const {
    state: stateParam,
    zone: zoneParam,
    woreda: woredaParam,
    kebele: kebeleParam,
  } = useParams();
  const navigate = useNavigate();
  const [selectedRegionalState, setSelectedRegionalState] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedWoreda, setSelectedWoreda] = useState("");
  const [selectedKebele, setSelectedKebele] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [factors, setFactors] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [missingZoneGEOJSON, setMissingZoneGEOJSON] = useState(false);
  const [missingWoredaGEOJSON, setMissingWoredaGEOJSON] = useState(false);
  const [regionalData, setRegionalData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [woredaData, setWoredaData] = useState([]);
  const [kebeleData, setKebeleData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      let regionalState = await getRegionalStates();
      setRegionalData(regionalState);
      let zone = await getZones();
      setZoneData(zone);
      let woreda = await getWoredas();
      setWoredaData(woreda);
      let kebele = await getKebeles();
      setKebeleData(kebele);
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };
  useEffect(() => {
    if (regionalData.length === 0) return;
    const stateName = fromUrl(stateParam || "");
    const zoneName = fromUrl(zoneParam || "");
    const woredaName = fromUrl(woredaParam || "");
    const kebeleName = fromUrl(kebeleParam || "");
    const stateObj = regionalData.find(
      (s) => s.regionalState.toLowerCase() === stateName.toLowerCase()
    );
    const properState = stateObj ? stateObj.regionalState : "";
    setSelectedRegionalState(properState);
    if (!stateParam || !zoneParam) return;
    const zoneObj = zoneData.find(
      (z) =>
        z.zone.toLowerCase() === zoneName.toLowerCase() &&
        z.regionalState === properState
    );
    const zoneMissing = zoneObj?.["Missing"];
    if (zoneMissing) {
      setMissingZoneGEOJSON(true);
    } else {
      setMissingZoneGEOJSON(false);
    }
    const properZone = zoneObj ? zoneObj.zone : "";
    setSelectedZone(properZone);
    const woredaObj = woredaData.find(
      (w) =>
        w.woreda.toLowerCase() === woredaName.toLowerCase() &&
        w.zone === properZone &&
        w.regionalState === properState
    );
    const woredaMissing = woredaObj?.["Missing"];
    if (woredaMissing) {
      setMissingWoredaGEOJSON(true);
    } else {
      setMissingWoredaGEOJSON(false);
    }
    const properWoreda = woredaObj ? woredaObj.woreda : selectedWoreda;
    setSelectedWoreda(properWoreda);
    const kebeleObj = kebeleData.find(
      (k) =>
        k.kebele.toLowerCase() === kebeleName.toLowerCase() &&
        k.woreda === properWoreda &&
        k.zone === properZone &&
        k.regionalState === properState
    );
    const properKebele = kebeleObj ? kebeleObj.kebele : "";
    setSelectedKebele(properKebele);
    if (kebeleObj) {
      setLatitude(kebeleObj.Latitude || "");
      setLongitude(kebeleObj.Longitude || "");
    } else if (woredaObj) {
      setLatitude(woredaObj.Latitude);
      setLongitude(woredaObj.Longitude);
    } else if (zoneObj) {
      setLatitude(zoneObj.Latitude);
      setLongitude(zoneObj.Longitude);
    } else if (stateObj) {
      setLatitude(stateObj.Latitude);
      setLongitude(stateObj.Longitude);
    } else {
      setLatitude("");
      setLongitude("");
    }
  }, [stateParam, zoneParam, woredaParam, kebeleParam, regionalData, zoneData, woredaData, kebeleData]);
  const handleRegionalStateChange = (e) => {
    const stateName = e.target.value;
    setSelectedRegionalState(stateName);
    setSelectedZone("");
    setSelectedWoreda("");
    setSelectedKebele("");
    const stateLoc = regionalData.find(
      (s) => s.regionalState === stateName
    );
    if (stateLoc) {
      setLatitude(stateLoc.Latitude);
      setLongitude(stateLoc.Longitude);
    } else {
      setLatitude("");
      setLongitude("");
    }

    setFactors("");
    setResult(null);
    navigate(`/region-select/${toUrl(stateName)}`);
  };
  const handleZoneChange = (e) => {
    const zoneName = e.target.value;
    setSelectedZone(zoneName);
    setSelectedWoreda("");
    setSelectedKebele("");
    const zoneLoc = zoneData.find(
      (z) =>
        z.zone === zoneName && z.regionalState === selectedRegionalState
    );
    if (zoneLoc) {
      setLatitude(zoneLoc.Latitude);
      setLongitude(zoneLoc.Longitude);
    } else {
      setLatitude("");
      setLongitude("");
    }
    setFactors("");
    setResult(null);
    navigate(`/region-select/${toUrl(selectedRegionalState)}/${toUrl(zoneName)}`);
  };
  const handleWoredaChange = (e) => {
    const woredaName = e.target.value;
    setSelectedWoreda(woredaName);
    setSelectedKebele("");
    setResult(null);
    const loc = woredaData.find(
      (w) =>
        w.woreda === woredaName &&
        w.zone === selectedZone &&
        w.regionalState === selectedRegionalState
    );
    if (loc) {
      setLatitude(loc.Latitude);
      setLongitude(loc.Longitude);
    }
    setLoading(true);
    try {
      const locationFactors = "dummy";
      setFactors(locationFactors);
    } catch (err) {
      toast.error("Failed to fetch factors.");
      setFactors({});
    } finally {
      setLoading(false);
    }
    navigate(
      `/region-select/${toUrl(selectedRegionalState)}/${toUrl(selectedZone)}/${toUrl(
        woredaName
      )}`
    );
  };
  const handleKebeleChange = (e) => {
    const kebeleName = e.target.value;
    setSelectedKebele(kebeleName);
    setResult(null);
    const loc = kebeleData.find(
      (k) =>
        k.kebele === kebeleName &&
        k.woreda === selectedWoreda &&
        k.zone === selectedZone &&
        k.regionalState === selectedRegionalState
    );
    if (loc) {
      setLatitude(loc.Latitude || "");
      setLongitude(loc.Longitude || "");
    }
    setLoading(true);
    try {
      const locationFactors = "dummy";
      setFactors(locationFactors);
    } catch (err) {
      toast.error("Failed to fetch factors.");
      setFactors({});
    } finally {
      setLoading(false);
    }

    navigate(
      `/region-select/${toUrl(selectedRegionalState)}/${toUrl(selectedZone)}/${toUrl(
        selectedWoreda
      )}/${toUrl(kebeleName)}`
    );
  };
  const zonesForState = zoneData
    .filter((z) => z.regionalState === selectedRegionalState)
    .map((z) => z.zone).sort();

  const woredasForZone = woredaData
    .filter((wd) => wd.regionalState === selectedRegionalState && wd.zone === selectedZone)
    .map((wd) => wd.woreda).sort();

  const kebelesForWoreda = kebeleData
    .filter((k) => k.woreda === selectedWoreda)
    .map((k) => k.kebele).sort();

  const selectRegionalState = (stateName) => {
    setSelectedRegionalState(stateName);
    setSelectedZone("");
    setSelectedWoreda("");
    setSelectedKebele("");
    navigate(`/region-select/${toUrl(stateName)}`);
  };

  const selectZone = (zoneName) => {
    setSelectedZone(zoneName);
    setSelectedWoreda("");
    setSelectedKebele("");
    navigate(`/region-select/${toUrl(selectedRegionalState)}/${toUrl(zoneName)}`);
  };

  const selectWoreda = (woredaName) => {
    setSelectedWoreda(woredaName);
    setSelectedKebele("");
    navigate(
      `/region-select/${toUrl(selectedRegionalState)}/${toUrl(selectedZone)}/${toUrl(
        woredaName
      )}`
    );
  };

  const selectKebele = (kebeleName) => {
    setSelectedKebele(kebeleName);
    navigate(
      `/region-select/${toUrl(selectedRegionalState)}/${toUrl(selectedZone)}/${toUrl(
        selectedWoreda
      )}/${toUrl(kebeleName)}`
    );
  };

  return (
    <>
      <Header />
      <div className="home">
        <ToastContainer />
        <Sidebar
          selectedRegionalState={selectedRegionalState}
          handleRegionalStateChange={handleRegionalStateChange}
          selectedZone={selectedZone}
          handleZoneChange={handleZoneChange}
          zonesForState={zonesForState}
          selectedWoreda={selectedWoreda}
          handleWoredaChange={handleWoredaChange}
          woredasForZone={woredasForZone}
          selectedKebele={selectedKebele}
          handleKebeleChange={handleKebeleChange}
          kebelesForWoreda={kebelesForWoreda}
          regional_state={regionalData}
        />
        <section className="map">
          <MapView
            selectedRegionalState={selectedRegionalState}
            selectedZone={selectedZone}
            selectedWoreda={selectedWoreda}
            selectedKebele={selectedKebele}
            latitude={latitude}
            longitude={longitude}
            onRegionClick={selectRegionalState}
            onZoneClick={selectZone}
            onWoredaClick={selectWoreda}
            onKebeleClick={selectKebele}
            missingZoneGEOJSON={missingZoneGEOJSON}
            missingWoredaGEOJSON={missingWoredaGEOJSON}
          />
        </section>
      </div>
    </>
  );
};

export default Home;